export var emailValidation = /^(?!°∞∆o€£"#%&♢♤♥♧♢)(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export var nameValidation = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]{1,30}$/;
export var heightValidation = /^[0-9]{2,3}$/;
export var couponValidation = /^[a-zA-Z0-9]{8}$/;
